const RELOAD_ATTEMPT_KEY = 'site-survey:stale-chunk-reload:v1';

function errorText(error: unknown): string {
  if (error instanceof Error) return `${error.name}\n${error.message}\n${error.stack || ''}`;
  if (typeof error === 'string') return error;
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}

export function isStaleChunkLoadError(error: unknown): boolean {
  const text = errorText(error);
  return /Failed to fetch dynamically imported module/i.test(text)
    || /error loading dynamically imported module/i.test(text)
    || /Importing a module script failed/i.test(text)
    || /Loading chunk \d+ failed/i.test(text)
    || /Unable to preload CSS for\s/i.test(text);
}

function reloadSignature(): string {
  if (typeof window === 'undefined') return '';
  const buildKey = window.__BUILD_COMMIT_SHA__ || window.__BUILD_RELEASE__ || '';
  return JSON.stringify({
    buildKey,
    path: `${window.location.pathname}${window.location.search}`,
  });
}

export function shouldReloadForStaleChunk(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const signature = reloadSignature();
    if (!signature) return false;
    const previous = window.sessionStorage.getItem(RELOAD_ATTEMPT_KEY);
    if (previous === signature) return false;
    window.sessionStorage.setItem(RELOAD_ATTEMPT_KEY, signature);
    return true;
  } catch {
    return false;
  }
}

export function clearStaleChunkReloadAttempt(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(RELOAD_ATTEMPT_KEY);
  } catch {
    // ignore storage restrictions
  }
}
